import _classCallCheck from "/home/mario/Desktop/projects_active/olmo/clients/2021/calchi-italiani/calchi-site/node_modules/@babel/runtime/helpers/esm/classCallCheck";
export var EmailJSResponseStatus = function EmailJSResponseStatus(httpResponse) {
  _classCallCheck(this, EmailJSResponseStatus);

  this.status = httpResponse.status;
  this.text = httpResponse.responseText;
};